import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const SiteLayout = ({ children }) => {
  return (
    <div className="site">
      <Navbar />
      <main className="site__main">{children}</main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
